
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Patient"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasUser"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ccEmailAddresses"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"zip"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"insuranceType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ableToConsent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"patientState"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"preparedConsultationsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"executedConsultationsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"internalId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userIsVerified"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasFollowUps"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"followUpsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nextFollowUpDueAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"userInvitations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInvitationFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AttachmentFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"consultations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConsultationFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"informationClarifications"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InformationClarificationFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"downloadContainers"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DownloadContainerFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":1038}};
    doc.loc.source = {"body":"#import \"./AttachmentFragment.graphql\"\n#import \"./ConsultationFragment.graphql\"\n#import \"./InformationClarificationFragment.graphql\"\n#import \"./AppointmentFragment.graphql\"\n#import \"./DownloadContainerFragment.graphql\"\n#import \"./UserFragment.graphql\"\n#import \"./UserInvitationFragment.graphql\"\n\nfragment PatientFragment on Patient {\n  id\n  firstName\n  lastName\n  email\n  hasUser\n  ccEmailAddresses\n  dateOfBirth\n  gender\n  streetAddress\n  zip\n  city\n  phone\n  insuranceType\n  ableToConsent\n  patientState\n  createdAt\n  updatedAt\n  preparedConsultationsCount\n  executedConsultationsCount\n  internalId\n  userIsVerified\n  hasFollowUps\n  followUpsCount\n  nextFollowUpDueAt\n  users {\n    ...UserFragment\n  }\n  userInvitations {\n    ...UserInvitationFragment\n  }\n  attachments {\n    ...AttachmentFragment\n  }\n  consultations {\n    ...ConsultationFragment\n  }\n  informationClarifications {\n    ...InformationClarificationFragment\n  }\n  appointments {\n    ...AppointmentFragment\n  }\n  downloadContainers {\n    ...DownloadContainerFragment\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./AttachmentFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./ConsultationFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./InformationClarificationFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./AppointmentFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./DownloadContainerFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./UserFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./UserInvitationFragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["PatientFragment"] = oneQuery(doc, "PatientFragment");
        
